// extracted by mini-css-extract-plugin
module.exports = {"text":"Illustrate_text__9uKmJ"};